<div class="clear"></div>
<section class="banner">
	<div class="container py-4">
		<h1>Request for Proposal</h1>
	</div>
</section>
<div class="clear p-4"></div>
<div class="container">
    <h6 class="mb-0 mb-3" style="font-style: italic; color: red;">Only 10 days old tenders from the closing date will be shown.</h6>
    <div class="clear p-2"></div>
    <div class="row align-items-center">
        <div class="col-lg-2">
            <label for="date">Closing Date</label>
			<input type="date" id="date" class="form-control" [(ngModel)]="ClosingDate">
        </div>
        <div class="col-lg-2">
            <label for="date">Tender No</label>
            <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">TS</span>
                </div>
                <input type="text" id="date" class="form-control" [(ngModel)]="TenderNumber">
                <div class="input-group-prepend">
                    <span class="input-group-text">E</span>
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <label for="date">City</label>
          <app-search-dropdown [items]="DropdownRecords" [size]="'small'" [img]="'product'" [label]="'name'" [uid]="'id'"
                               [(ngModel)]="selectedStateID">
          </app-search-dropdown>
        </div>

        <div class="col-lg-2 mt-4">
           <button type="submit" (click)="onSelectValueSearch()" class="btn btn-primary">Search</button>
           <button  type="Clear"  (click)="clears()" class="btn btn-secondary ml-2">Clear</button>
        </div>
    </div>
    <div class="row justify-content-end align-items-center">
        <strong class="font-weight-bold col-lg-4 text-right">Total Records ({{totalRecords}})</strong>
    </div>
    <div class="clear p-2"></div>
    <div class="table-responsive">
      <table class="table border sortable">
        <thead class="table-primary">
        <tr>
          <th scope="col">Sr NO.</th>
          <th scope="col">
            <div class="sortTh">
              Tender NO
              <span class="sorted_Icons">
                                <a (click)="sort('tse','desc')"><img  src="../assets/images/arrow_up.gif"></a>
                                <a (click)="sort('tse','asc')"><img src="../assets/images/arrow_down.gif"></a>
                            </span>
            </div>
          </th>
          <th scope="col">Tender Details</th>
          <th scope="col">Downloads</th>
          <th scope="col">
            <div class="sortTh">
              Advertisement Date
              <span class="sorted_Icons">
                                <a (click)="sort('start_date','desc')"><img  src="../assets/images/arrow_up.gif"></a>
                                <a (click)="sort('start_date','asc')"><img src="../assets/images/arrow_down.gif"></a>
                            </span>
            </div>
          </th>
          <th scope="col">
            <div class="sortTh">
              Closing Date
              <span class="sorted_Icons">
                                <a (click)="sort('closing_date','desc')"><img  src="../assets/images/arrow_up.gif"></a>
                                <a (click)="sort('closing_date','asc')"><img src="../assets/images/arrow_down.gif"></a>
                            </span>
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of Records; let i = index">
          <td>
            <strong>{{i+1}}</strong><br>
          </td>
          <td>
            <strong>{{data?.tse}}</strong>
            <br>
            <a href="javascript:void(0)" (click)="openTenderDetails(data)" data-toggle="tooltip" class="btn btn-rounded alert-info m-1 btn-sm shadow-none font-weight-medium py-2 px-3" title="View Details">
              View Invoice
            </a>
            <br>

          </td>
          <td>


            <strong>{{data?.CategoryName}},<span *ngIf="data.Isweb==0">{{data?.state_name}}</span><span
              *ngIf="data.Isweb==1">{{data?.UserCityNameState}}</span> <span *ngIf="data.countryname">,
              {{data.countryname}}</span> </strong><br>
            {{data?.Tender_Title}} <br>
            {{data?.note}} <br>

            <span  *ngIf="data.RuleNO && data.IsCompliance==false">PPRA Rule Violation:<strong> {{data.RuleNO}}</strong>
                            <br ><span  *ngIf="data.IsCompliance==true">PPRA Rule Compliance:<strong> {{data.ComplianceDate}}</strong></span>

                            </span>

          </td>
          <td class="text-center align-middle">

            <a *ngIf="data?.Isweb==1 "  href="javascript:void(0)" (click)="openOnlineTenderDetails(data)" data-toggle="tooltip" title="View Details"><i class="fas fa-file-download fa-fw fa-lg text-success"></i></a>
            <span *ngIf="data?.Isweb==0 "  >
                        <a *ngIf="data?.TenderurlattachmentID==null" [href]="data?.URL" target="_blank" data-toggle="tooltip" title="Tender"><i class="fas fa-file-download fa-fw fa-lg"></i></a>

                        <a *ngIf="data?.TenderurlattachmentID!=null" (click)="getAttachmentByGUID(data?.TenderurlattachmentID)" data-toggle="tooltip" title="Download"><i class="fas fa-file-download fa-fw fa-lg text-success"></i></a>
                      </span>
            <br>

            <div class="badge text-white bg-secondary mt-2" *ngIf="data?.status==15">
              <a *ngIf="data?.FileGuid_Corrigendum!=null" (click)="getAttachmentByGUID(data?.FileGuid_Corrigendum)" data-toggle="tooltip" title="Corrigendum">Corrigendum</a>

              <a *ngIf="data?.FileGuid_Corrigendum==null" data-toggle="tooltip" title="Corrigendum">Corrigendum</a>

            </div>



            <div class="badge text-white bg-secondary mt-2" *ngIf="data?.status==16">
              <a *ngIf="data?.FileGuid_Cancel!=null" (click)="getAttachmentByGUID(data?.FileGuid_Cancel)" data-toggle="tooltip" title="Cancellation">Cancellation</a>
              <a *ngIf="data?.FileGuid_Cancel==null" data-toggle="tooltip" title="Cancellation">Cancellation</a>

            </div>

          </td>

          <td  class="text-center align-middle">
            <strong >{{data?.start_date | date}}</strong><br>
          </td>
          <td  class="text-center align-middle">
            <strong >{{data?.closing_date | date}}</strong><br>
          </td>

        </tr>
        <strong *ngIf="Records?.length == '0'">No record found.</strong>
        </tbody>
      </table>
        <div class="clear clearfix py-1"></div>

        <small class="font_12">10 Records Per Page</small>
        <small class="font_12"> | Total Pages<strong>  {{this.totalPages}}</strong></small>
        <nav aria-label="..." class="arial-pagination">
            <div class="d-flex">
                <ul class="pagination justify-content-center">
                    <li class="page-item" [class.disabled]="this.PageNo === 1">
                        <a class="page-link" (click)="previousPage()">Previous</a>
                    </li>
                    <li class="page-item" *ngFor="let pageNumber of pages">
                        <a class="page-link" (click)="changePage(pageNumber)" [class.active]="pageNumber === this.PageNo">{{pageNumber}}</a>
                    </li>
                    <li class="page-item" [class.disabled]="this.PageNo=== this.totalPages">
                        <a class="page-link" (click)="nextPage()">Next</a>
                    </li>
                </ul>
                <div class="input-group input-group-sm ml-4">
                    <input type="number" class="form-control" placeholder="Page No."  (keyup)="onEnterKeyPressed($event)"  [(ngModel)]="this.PN" aria-label="Enter your text" aria-describedby="button-addon">
                    <div class="input-group-append input-group-sm">
                      <button class="btn btn-outline-secondary"  (click)="selectedPage()" type="button" id="button-addon">Go</button>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</div>
<div class="clear p-4"></div>
